import { Component } from '.';
import { Transform, TransformPosition, Color } from '../../interfaces';

/**
 * Line renderer component.
 */
export class LineRenderer extends Component {
	public state: {
		points: Array<TransformPosition>;
		color: Color | Array<Color>;
		visibility?: number;
		transform?: Transform;
		isDashed?: boolean;
		dashSize?: number;
		gapSize?: number;
		dashNb?: number;
	} = {
		visibility: 1,
		transform: { position: { x: 0, y: 0, z: 0 } },
		points: [],
		color: { r: 0, g: 0, b: 1 },
	};
}
